import {Injectable} from '@angular/core';
import {BaseProvider} from '../base.provider';
import {ModelsInterfaces} from '@namespaces/models.namespace';
import {MethodsService} from './methods.service';

@Injectable()
export class MethodsProvider extends BaseProvider<MethodsData> {
    public defaultValue: MethodsData = {
        all: [],
        asTree: [],
        asRoot: [],
        asKeys: {},
    };

    constructor(
        service: MethodsService
    ) {
        super(service);
        /**
         * Устанавливаем дефолтные значения
         */
        this.data$.next(this.defaultValue);
        this.updateData();
    }

    processedData(data: ModelsInterfaces.Method[] = []): MethodsData {
        if (!(data instanceof Array)) {
            data = [];
        }
        const rootMethods = this.getMethodsRoot(data);
        return {
            all: data, // Все методы
            asRoot: rootMethods, // Только корневые методы
            asTree: this.getMethodsAsTree(data),
            asKeys: this.getMethodsByKey(rootMethods) // Корневые методы в виде объекта с ключом, равным аббревиатуре метода
        };
    }

    public getByShortTitle(shortTitle: string) {
        if (!shortTitle) {
            return null;
        }

        const methods = this.data$.getValue().asTree || [];

        return methods.find(m => m.short_title === shortTitle);
    }

    public getById(id: number) {
        if (!id) {
            return null;
        }

        const methods = this.data$.getValue().asTree || [];

        return methods.find(m => +m.id === +id);
    }

    /* Делаем из плоской коллекции методов структуру данных в виде дерева, где подметоды будут внутри своего родителя
     * В условиях, что у нас только один уровень потомка, подобная реализация справедлива и при этом быстра.
     * */
    private getMethodsAsTree(data: ModelsInterfaces.Method[]): ModelsInterfaces.Method[] {
        const root = this.getMethodsRoot(data);

        const asTreeArray = [];

        root.forEach(method => {
            asTreeArray.push({...method});
        });


        data.forEach(item => {
            const { parent_id } = item;
            const method = asTreeArray.find(m => +m.id === +parent_id);

            if (method) {
                if (!method.methods) {
                    method.methods = [];
                }

                method.methods.push({...item});
            }
        });

        return asTreeArray;
    }

    private getMethodsRoot(data: ModelsInterfaces.Method[]): ModelsInterfaces.Method[] {
        return data.filter(item => +item.parent_id === 1);
    }

    private getMethodsByKey(data: ModelsInterfaces.Method[]) {
        const asKeys = {};
        data.forEach(item => {
            const key = item.short_title;
            asKeys[key] = item;
        });
        return asKeys;
    }
}

export interface MethodsData {
    all: ModelsInterfaces.Method[];
    asRoot: ModelsInterfaces.Method[];
    asTree: ModelsInterfaces.Method[];
    asKeys: {
        [key: string]: ModelsInterfaces.Method[]
    };
}
